import { faExclamationTriangle, faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from 'moment';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Popup } from 'reactjs-popup';
import logo1 from "../../../../assets/table-img.svg";
import logo2 from "../../../../assets/table-img2.svg";
import { config } from "../../../../config";
import axiosApi from "../../../../core/interceptor/interceptor";
import { messages } from "../../../../messages";
import { contactUsCount, setContactUsCount } from "../../../../Store/reducers/ContactUsReducer";
import Checkbox from '../../../../Util/Checkbox/Checkbox';
import DataTableComponent from "../../../../Util/DataTable/DataTable";
import { formatPhoneNumber } from "../../../../Util/helper";
import WarningDialogue from '../../../../Util/WarningDialogue';
import "./AdminContactUs.css";
import ViewContactUs from './ViewContactUs/ViewContactUs';

function ContactUs() {
  const columns = [
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Name</div>,
      selector: () => 'full_name',
      className: 'left-align',
      minWidth: '130px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', textAlign: 'left', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.full_name ? `${row.full_name}` : 'N/A'}{row.platform === 'C' ? <img src={logo1} alt='icon' /> : <img className="icon" src={logo2} alt='icon' />}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Email</div>,
      selector: () => 'email',
      minWidth: '160px !important',
      sortable: 'true',
      style: {
        padding: '0',
        whiteSpace: 'pre-wrap !important'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', justifyContent: 'flex-start !important', textAlign: 'left', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.email ? row.email : 'N/A'}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Date</div>,
      selector: () => 'created_at',
      minWidth: '160px !important',
      sortable: 'true',
      style: {
        padding: '0',
        whiteSpace: 'pre-wrap !important'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', justifyContent: 'flex-start !important', textAlign: 'left', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.created_at ? moment(row.created_at).format('MM/DD/YYYY, h:mm a') : 'N/A'}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Phone</div>,
      selector: () => 'phone',
      minWidth: '130px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.phone ? formatPhoneNumber(row.phone) : 'N/A'}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Is Resolved</div>,
      selector: () => 'resolved',
      minWidth: '130px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }} >
        <Checkbox checked={Number(row.resolved) === 1 ? true : false} onMouseDown={() => { handleInputChange(row.id, row.resolved) }} />
      </div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Address</div>,
      selector: () => 'address',
      minWidth: '136px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{(row.address || 'N/A')}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Message</div>,
      selector: () => 'message',
      minWidth: '98px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell msg-col" data-tag="allowRowEvents" style={{ width: '100%', alignItems: 'center', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.message ? row.message : 'N/A'}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Action</div>,
      selector: () => 'message',
      minWidth: '98px !important',
      sortable: false,
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}><button title='View' className="icon-btn" onClick={() => { viewContactUsModel(); setData(row); }}><FontAwesomeIcon icon={faEye} className='warning-icon' /></button></div>)
    },
  ];
  const dispatch = useDispatch();
  const contactCount = useSelector(contactUsCount);
  const handleInputChange = (id, resolved) => {
    setOpenWarningPopup(true);
    setPopUpContent({
      header: 'Warning',
      description: messages[Number(resolved) === 0 ? 'contact_resolved_status' : 'contact_un_resolved_status'],
      icon: faExclamationTriangle,
      action: () => {
        axiosApi.put(`${config.apiUrl}/contact-us/${id}`, {
          resolved: Number(resolved) === 1 ? 0 : 1,
        })
          .then((response) => {
            getContactUs();
            if (Number(resolved) === 1) {

              dispatch(setContactUsCount(contactCount + 1));
            } else {
              dispatch(setContactUsCount(contactCount - 1));
            }
            setOpenWarningPopup(false);
          })
          .catch((error) => {
            setOpenWarningPopup(false);
          });
      }
    });

  }
  const [data, setData] = useState();
  const [userData, setUserData] = useState([]);
  const [openWarningPopup, setOpenWarningPopup] = useState(false);
  const [popUpContent, setPopUpContent] = useState({});
  const [view, setView] = useState(false);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 50,
    sort_column: 'resolved',
    direction: 'asc',
  });
  const [totalPage, setTotalPage] = useState(0);
  const getContactUs = () => {
    axiosApi.get(`${config.apiUrl}/contact-us`, {
      params: filter,
    })
      .then((response) => {
        setUserData(response.data.data.rows);
        setTotalPage(response.data.data.count);
      });
  }


  useEffect(() => {
    const getContactUs = () => {
      axiosApi.get(`${config.apiUrl}/contact-us`, {
        params: filter,
      })
        .then((response) => {
          setUserData(response.data.data.rows);
          setTotalPage(response.data.data.count);
        });
    }
    getContactUs();
  }, [filter])

  const viewContactUsModel = () => {
    setView(true);
  }

  const closeView = () => {
    setView(false);
  }

  return (
    <>
      <div className="content-wrapper sendEmail-wrapper contactUs-wrapper" >
        <div className="header">
          <div className="header-blk common-head-block">
            <h2> Contact Us</h2>
            <p>select user to send email.</p>
          </div>
        </div>
        <div className="table-wrapper">
          <div className="dataTable">
            <DataTableComponent key="table-admin-users"
              type={'contact-us'}
              data={userData}
              disableRowClicked={true}
              columns={columns}
              onFilterChange={(event) => {
                setFilter((prev) => {
                  if (event.type === 'sort') {
                    return {
                      ...prev,
                      sort_column: event.target.value,
                      direction: event.target.direction,
                    }
                  }
                  return {
                    ...prev,
                    [event.target.name]: Number(event.target.value),
                  }
                })
              }}
              totalPage={totalPage} />
          </div>
        </div>
      </div>
      <Popup open={view} onClose={closeView} closeOnDocumentClick={false} className='contact-modal'>
        <ViewContactUs closeModal={() => closeView()} refresh={() => { closeView(); getContactUs() }} data={data} />
      </Popup>
      <WarningDialogue
        isOpen={openWarningPopup}
        header={popUpContent.header}
        description={popUpContent.description}
        icon={popUpContent.icon}
        action={popUpContent.action}
        onClose={() => setOpenWarningPopup(false)}
      />
    </>
  );
}

export default ContactUs;